import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {Doughnut, Line} from "react-chartjs-2";
import {
    ArcElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip,
} from "chart.js";
import useDynamicColors from "../../hooks/useDynamicColors";
import "./style.css";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
);

const optionsDoughnut = {
    plugins: {
        legend: {
            labels: {
                usePointStyle: true, // Hace que las leyendas usen puntos en lugar de barras
                pointStyle: "circle", // Establece el estilo del punto a círculo
            },
        },
    },
};

const options = {
    scales: {
        x: {
            grid: {
                display: false, // Oculta las líneas de cuadrícula en el eje X
            },
        },
        y: {
            grid: {
                display: false, // Oculta las líneas de cuadrícula en el eje Y
            },
        },
    },
};

export const UserDashboard = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const colors = useDynamicColors();

    // Styles

    const laptop = {
        marginTop: "30px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#333",
        borderRadius: "15px 15px 5px 5px",
        padding: "10px",
        width: "960px",
        height: "500px",
        position: "relative",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
    };

    const screen = {
        backgroundColor: "white",
        borderRadius: "5px",
        overflowY: "scroll",
        overflowX: "hidden",
        width: "100%",
        height: "500px",
    };

    const container = {
        display: "flex",
        height: "100vh",
    };

    const base = {
        position: "absolute",
        width: "1100px",
        height: "20px",
        backgroundColor: "rgb(170, 170, 170)",
        borderRadius: "0px 0px 10px 10px",
        bottom: 0,
    };

    const navLinkStyle = {
        display: "flex",
        alignItems: "center",
        padding: "10px",
        color: colors.primario,
        textDecoration: "none",
        borderRadius: "5px",
        fontSize: "0.8em",
        fontWeight: "200",
        gap: "10px",
    };

    const inputStyle = {
        padding: "10px",
        border: `1px solid ${colors.primario}`,
        borderRadius: "5px",
        width: "150px",
    };

    const headerCellStyle = {
        padding: "10px",
        fontWeight: "bold",
        color: "#333333",
    };

    const cellStyle = {
        padding: "10px",
    };

    const handleButtonClick = () => {
        const currentParams = location.search;
        navigate(`/backoffice-user_details-corporativo-web${currentParams}`);
    };

    const lineData = {
        labels: ["<18", "19-29", "30-39", "40-49", "50-59", ">60"],
        datasets: [
            {
                label: "",
                data: [5, 20, 30, 15, 10, 2],
                borderColor: `${colors.primario}`,
                backgroundColor: "rgba(0, 102, 255, 0.3)",
                fill: false,
            },
        ],
    };

    const doughnutData = {
        labels: ["Male", "Female"],
        datasets: [
            {
                data: [35, 65],
                backgroundColor: [`${colors.secundario}`, `${colors.primario}`],
                hoverBackgroundColor: [colors.secundario, colors.primario],
            },
        ],
    };

    const doughnutDataSystem = {
        labels: ["Ios", "Android"],
        datasets: [
            {
                data: [88, 12],
                backgroundColor: [`${colors.secundario}`, `${colors.primario}`],
                hoverBackgroundColor: [colors.secundario,colors.primario],
            },
        ],
    };

    return (
        <div style={laptop}>
            <div style={screen}>
                <div style={container}>
                    <div style={{ display: "flex", fontFamily: "Inter" }}>
                        {/* Navbar */}
                        <div
                            style={{
                                width: "150px",
                                backgroundColor: "#E0E0E0",
                                padding: "20px",
                                height: "100vh",
                                boxSizing: "border-box",
                            }}
                        >
                            <div style={{textAlign: "center", marginBottom: "20px"}}>
                                <img
                                    src={
                                        colors.url_logo ??
                                        "https://vxapp.wfsystems.com.ar/storage/logos/20240416192440.png"
                                    }
                                    alt="Logo"
                                    style={{width: "60px", marginBottom: "10px"}}
                                />

                                <p
                                    style={{
                                        color: `${colors.primario}`,
                                        fontSize: "0.8em",
                                        fontWeight: "300",
                                        marginTop: 10,
                                    }}
                                >
                                    It's nice to see u!
                                </p>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "15px",
                                }}
                            >
                                <a href="#" style={navLinkStyle}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 448 512"
                                        width={20}
                                        height={20}
                                        fill={colors.secundario}
                                    >
                                        <path
                                            d="M96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm94.5 200.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7H162.5c0 0 0 0 .1 0H168 280h5.5c0 0 0 0 .1 0H417.3c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2H224 204.3c-12.4 0-20.1 13.6-13.7 24.2z"
                                            fill={colors.secundario}
                                        ></path>
                                    </svg>
                                    Users
                                </a>
                                <a href="#" style={navLinkStyle}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        width={20}
                                        height={20}
                                        fill={colors.secundario}
                                    >
                                        <path
                                            d="M64 0C46.3 0 32 14.3 32 32l0 64c0 17.7 14.3 32 32 32l80 0 0 32-57 0c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1C.4 368.8 0 373.6 0 378.4L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-69.6c0-4.8-.4-9.6-1.1-14.4L488.2 214.4C483.5 183.1 456.6 160 425 160l-217 0 0-32 80 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L64 0zM96 48l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 432c0-8.8 7.2-16 16-16l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16zm48-168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM160 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM424 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM352 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"
                                            fill={colors.secundario}
                                        ></path>
                                    </svg>
                                    Merchants
                                </a>
                                <a href="#" style={navLinkStyle}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        width={20}
                                        height={20}
                                        fill={colors.secundario}
                                    >
                                        <path
                                            d="M96 96c0-35.3 28.7-64 64-64l288 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L80 480c-44.2 0-80-35.8-80-80L0 128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 272c0 8.8 7.2 16 16 16s16-7.2 16-16L96 96zm64 24l0 80c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24L184 96c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16z"
                                            fill={colors.secundario}
                                        ></path>
                                    </svg>
                                    Banners
                                </a>
                                <a href="#" style={navLinkStyle}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 640 512"
                                        width={20}
                                        height={20}
                                        fill={colors.secundario}
                                    >
                                        <path
                                            d="M48 48l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 0C14.3 0 0 14.3 0 32L0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7l56.1 0c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4l-69.3 0zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3l-69.3 0c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6l56.1 0zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1l-80 0c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM504 48l88 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104c0-17.7-14.3-32-32-32L504 0c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464l0-88c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 480c0 17.7 14.3 32 32 32l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c17.7 0 32-14.3 32-32l0-104c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88-88 0z"
                                            fill={colors.secundario}
                                        ></path>
                                    </svg>
                                    Campaigns
                                </a>
                                <a href="#" style={navLinkStyle}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        width={20}
                                        height={20}
                                        fill={colors.secundario}
                                    >
                                        <path
                                            d="M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                                            fill={colors.secundario}
                                        ></path>
                                    </svg>
                                    Audits
                                </a>
                            </div>
                        </div>

                        {/* Dashboard Content */}
                        <div
                            style={{
                                flexGrow: 1,
                                padding: "20px",
                                backgroundColor: "#F3F4F6",
                            }}
                        >
                            {/* Header */}
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    backgroundColor: `${colors.primario}`,
                                    color: "white",
                                    padding: "15px",
                                    marginLeft: -20,
                                    marginRight: -20,
                                    marginTop: -20,
                                    // borderRadius: "8px 8px 0 0",
                                }}
                            >
                                <h1 style={{ fontSize: "1em", fontWeight: "bold" }}>
                                    Dashboard Administrator
                                </h1>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                        }}
                                    >
                                        <p style={{ marginRight: "20px" }}>User</p>
                                        <p style={{ marginRight: "20px" }}>Admin</p>
                                    </div>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        width={20}
                                        height={20}
                                        fill="#FFFFFF"
                                    >
                                        <path
                                            d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            width={20}
                                            height={20}
                                            fill="#FFFFFF"
                                        ></path>
                                    </svg>
                                    <div style={{ marginLeft: 15 }}>
                                        <path
                                            d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
                                            fill="#FFFFFF"
                                        ></path>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            width={20}
                                            height={20}
                                            fill="#FFFFFF"
                                        >
                                            <path
                                                d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
                                                fill="#FFFFFF"
                                            ></path>
                                        </svg>
                                    </div>
                                    {/* <button
              style={{
                backgroundColor: "#004BBB",
                padding: "10px",
                borderRadius: "5px",
                marginLeft: 15,
                color: "white",
                border: "none",
                cursor: "pointer",
              }}
            >
              Settings
            </button> */}
                                </div>
                            </div>

                            {/* Rest of the Dashboard Content */}
                            {/* Existing components like charts, filter/search section, and table */}
                            <div
                                style={{
                                    display: "flex",
                                    marginTop: "20px",
                                    gap: "15px",
                                    minHeight: 185,
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: "#FFFFFF",
                                        padding: "20px",
                                        borderRadius: "8px",
                                        width: "65%",
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            textAlign: "center",
                                            marginRight: "20px",
                                        }}
                                    >
                                        <img
                                            src="img/QR.png"
                                            alt="QR Code"
                                            style={{ width: "100px", marginBottom: "10px" }}
                                        />
                                        <span
                                            style={{
                                                color: `${colors.primario}`,
                                                fontWeight: "bold",
                                                fontSize: "0.7em",
                                            }}
                                        >
                      Download VXApp and Try Me!
                    </span>
                                    </div>

                                    <div style={{ textAlign: "center", flex: 1 }}>
                                        <h2
                                            style={{
                                                color: `${colors.primario}`,
                                                fontSize: "1.5em",
                                                fontWeight: "600",
                                            }}
                                        >
                                            VXApp Experience
                                        </h2>

                                        <p
                                            style={{
                                                fontSize: "1em",
                                                marginTop: 10,
                                                color: `${colors.primario}`,
                                                fontWeight: "bold",
                                            }}
                                        >
                                            62 Active Users
                                        </p>
                                        <hr style={{ margin: "10px 0", borderColor: "#f7f7f7" }} />

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-around",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            <div style={{ color: "green" }}>
                                                <span>Actives</span>
                                                <div style={{ fontSize: "1.2em" }}>55</div>
                                            </div>
                                            <div style={{ color: "blue" }}>
                                                <span>Review</span>
                                                <div style={{ fontSize: "1.2em" }}>4</div>
                                            </div>
                                            <div style={{ color: "red" }}>
                                                <span>Rejected</span>
                                                <div style={{ fontSize: "1.2em" }}>3</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* <div
            style={{
              backgroundColor: "white",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              padding: "20px",
              borderRadius: "8px",
              width: "25%",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <img
                src="https://vxapp.wfsystems.com.ar/storage/logos/20240416192440.png"
                alt="Logo"
                style={{ width: "60px", marginBottom: "15px" }}
              />
              <h2
                style={{
                  color: `${colors.primario}`,
                  fontSize: "1.2em",
                  fontWeight: "600",
                }}
              >
                User Metrics
              </h2>
              <p style={{ fontSize: "0.9em", color: "#606060" }}>
                62 Active Users
              </p>
            </div>
            <Doughnut data={doughnutData} />
          </div> */}
                                {/* Right Column */}
                                <div
                                    style={{
                                        backgroundColor: "white",
                                        padding: "20px",
                                        borderRadius: "8px",
                                        width: "35%",
                                        flexGrow: 1,
                                    }}
                                >
                                    <Line data={lineData} options={options} />{" "}
                                    <h2
                                        style={{
                                            color: `${colors.primario}`,
                                            fontSize: "1em",
                                            fontWeight: "600",
                                            marginBottom: 10,
                                            marginTop: 10,
                                        }}
                                    >
                                        Last 30 Days Evolution
                                    </h2>
                                </div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    marginTop: "20px",
                                    gap: "15px",
                                    minHeight: 185,
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "top",
                                        justifyContent: "center",
                                        backgroundColor: "#FFFFFF",
                                        padding: "5px",
                                        borderRadius: "8px",
                                        width: "65%",
                                    }}
                                >
                                    <div
                                        style={{
                                            backgroundColor: "white",
                                            padding: "10px",
                                            borderRadius: "8px",
                                            width: "50%",
                                        }}
                                    >
                                        <div style={{ textAlign: "center" }}>

                                        </div>
                                        <Doughnut data={doughnutData} options={optionsDoughnut} />
                                    </div>

                                    <div
                                        style={{
                                            backgroundColor: "white",
                                            padding: "10px",
                                            borderRadius: "8px",
                                            width: "50%",
                                        }}
                                    >
                                        <div style={{ textAlign: "center" }}></div>
                                        <Doughnut
                                            data={doughnutDataSystem}
                                            options={optionsDoughnut}
                                        />
                                    </div>
                                </div>

                                {/* <div
            style={{
              backgroundColor: "white",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              padding: "20px",
              borderRadius: "8px",
              width: "25%",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <img
                src="https://vxapp.wfsystems.com.ar/storage/logos/20240416192440.png"
                alt="Logo"
                style={{ width: "60px", marginBottom: "15px" }}
              />
              <h2
                style={{
                  color: `${colors.primario}`,
                  fontSize: "1.2em",
                  fontWeight: "600",
                }}
              >
                User Metrics
              </h2>
              <p style={{ fontSize: "0.9em", color: "#606060" }}>
                62 Active Users
              </p>
            </div>
            <Doughnut data={doughnutData} />
          </div> */}
                                {/* Right Column */}
                                <div
                                    style={{
                                        backgroundColor: "white",
                                        padding: "20px",
                                        borderRadius: "8px",
                                        width: "35%",
                                        flexGrow: 1,
                                    }}
                                >
                                    <Line data={lineData} options={options} />{" "}
                                    <h2
                                        style={{
                                            color: `${colors.primario}`,
                                            fontSize: "1em",
                                            fontWeight: "600",
                                            marginBottom: 10,
                                            marginTop: 10,
                                        }}
                                    >
                                        Age Segmentation
                                    </h2>
                                </div>
                            </div>

                            {/* Filter and Search Section */}
                            <div
                                style={{
                                    backgroundColor: "white",
                                    padding: "20px",
                                    marginTop: "20px",
                                    borderRadius: "8px",
                                    display: "flex",
                                    gap: "10px",
                                }}
                            >
                                <input type="text" placeholder="Name" style={inputStyle} />
                                <select style={inputStyle}>
                                    <option>User Status</option>
                                    <option>Active</option>
                                    <option>Inactive</option>
                                </select>
                                <input type="date" style={inputStyle} />
                                <input type="date" style={inputStyle} />
                                <button
                                    style={{
                                        backgroundColor: `${colors.primario}`,
                                        color: "white",
                                        padding: "10px 15px",
                                        borderRadius: "5px",
                                        border: "none",
                                        cursor: "pointer",
                                    }}
                                >
                                    Search
                                </button>
                            </div>

                            {/* User Table */}
                            <div
                                style={{
                                    backgroundColor: "white",
                                    padding: "20px",
                                    marginTop: "20px",
                                    borderRadius: "8px",
                                }}
                            >
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <thead>
                                    <tr style={{ textAlign: "left" }}>
                                        <th style={headerCellStyle}>Id</th>
                                        <th style={headerCellStyle}>User Details</th>
                                        <th style={headerCellStyle}>Contact Info</th>
                                        <th style={headerCellStyle}>Status</th>
                                        <th style={headerCellStyle}>Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr style={{ borderBottom: "1px solid #E0E0E0" }}>
                                        <td style={cellStyle}>1</td>
                                        <td style={cellStyle}>John Doe</td>
                                        <td style={cellStyle}>johndoe@example.com</td>
                                        <td style={cellStyle}>
                        <span
                            style={{
                                backgroundColor: "#00c228",
                                color: "#ffffff",
                                padding: "5px 10px",
                                borderRadius: "5px",
                            }}
                        >
                          Approved
                        </span>
                                        </td>
                                        <td style={cellStyle}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    gap: 12,
                                                }}
                                            >
                                                <div
                                                    onClick={handleButtonClick}
                                                    className="highlighted-button"
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 512 512"
                                                        width={20}
                                                        height={20}
                                                        fill={colors.primario}
                                                    >
                                                        <path
                                                            d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                                                            fill={colors.primario}
                                                        ></path>
                                                    </svg>
                                                </div>
                                                <div>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 448 512"
                                                        width={20}
                                                        height={20}
                                                        fill="#F44336"
                                                    >
                                                        <path
                                                            d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z"
                                                            fill="#F44336"
                                                        ></path>
                                                    </svg>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={base}></div>
        </div>
    );
};
